export const HOTBAR_SLOT_COUNT = 18;
export function hotbarIndex(code: string, shift: boolean): number | null {
  return /^Digit[1-9]$/.test(code) ? Number(code.slice(5)) - 1 + (shift ? 9 : 0) : null;
}
export function hotbarLabel(index: number): string {
  return `${index >= 9 ? 'Shift+' : ''}${index % 9 + 1}`;
}
